module.exports = __webpack_public_path__ + "static/media/logo.5291eff6.png";